export const tip = [
    'Banana-mod is cool',
    '@carters3421 on Scratch made the Purple Square Guy Sprite, its basically his mascot!',
    'Also check out <a style="color: lightgray;" href="https://librekitten.org/">LibreKitten</a>!',
    'Banana-mod is based off the source code of Merrcode, which is based off TurboWarp, which is based off Scratch. M O D C E P T I O N.',
    'Crazy? I was crazy once. They locked me in a room, a rubber room. A rubber room with rats. And rats make me crazy.',
    "Banana-mod",
    "I LOVE BANANA-MOD!!!",
    "In 2089, literally nothing will happen.",
    "Did you know? You can post your projects outside of the Snail IDE community.",
    "number 15 burger king foot lettuce",
    "thepython555 the goat",
    "Bananas",
    "merrcode:codemerr, penguinmod:menguinpod, snail-ide:ide-snail",
    "The first project to be uploaded that still exists is SnailGPT by Mr_rudy, keep in mind this lasted through over 3 server changes",
    "Blud is reading this tip 💀💀💀",
    "Banana are delicious",
    "Suprising fact: Snail IDE used to have inconsistent coloring. :O",
    "Maybe in another universe, snails are the fastest animal.",
    "A snail (or was it Bibi?) just ate your soul. /j (or is it?)",
    '<a style="color: lightgray;" href="https://scratch.mit.edu/users/o97doge/">o97doge was here.</a>',
    'oh no cringe',
    'me when i wake up in the middle of the night<br/><img src="https://corsproxy.io/?https%3A%2F%2Fpbs.twimg.com%2Fmedia%2FFZyQ8-eagAAunGr%3Fformat%3Djpg%26name%3Dmedium" width="50" height="50"/>',
    'The name of Banana-mod was inspired by my friend that loves bananas. <small>(not gandi ide)</small>',
    '4 mods deep!'
];
